import React, { useEffect } from 'react';
import WelcomeComponent from '../../common/WelcomeComponent';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ROUTE_DASHBOARD } from '../../navigation/constants';

function WelcomeScreen({ history }) {
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const mainHeading = 'Welcome to the Litterati Dashboard';
    const pointHeading = 'To get started:';
    const points = [
        'Log in to the Litterati mobile app on your phone, Use the same email + password you just created here.',
        'In the mobile app, go to the Challenges tab & create a challenge.',
        ' In the mobile app, go into the Camera. Take and upload a few photos (aka LitterPics)',
    ];
    const descriptionHeading = 'Note:';
    const description = (
        <>
            <p>You can always delete the challenge or any LitterPics later.</p>
            <p>
                This is just to show you how everything works so feel free to
                take a picture of anything now, just to test it out.
            </p>
            <p>
                For more resources on how to use the Litterati Dashboard, check
                your email or contact us{' '}
                <a href="mailto:support@litterati.org">support@litterati.org</a>
            </p>
        </>
    );

    const buttonText = 'Get Started';

    return (
        <WelcomeComponent
            mainHeading={mainHeading}
            pointHeading={pointHeading}
            points={points}
            descriptionHeading={descriptionHeading}
            description={description}
            buttonText={buttonText}
            onClick={() => {
                history.push({ pathname: ROUTE_DASHBOARD });
            }}
        />
    );
}

WelcomeScreen.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
};

export default withRouter(WelcomeScreen);
